import FroalaEditor from 'froala-editor';

import { warning as showNotificationWarning }
  from 'zoomforth_app_basics/action_creators/notifications.js';

import { openTextTranslationModal }
  from 'zoomforth_codesbane_editor/action_creators/translations.js';


export const TRANSLATE_TEXT_PLUGIN = 'zfTranslateTextPlugin';
export const TRANSLATE_TEXT_PLUGIN_ICON = 'zfTranslateTextPlugin.icon';


export const translateTextPlugin = (editor, store) => {

  function pluginTranslateText() {
    /**
     * Unfortunately this means that we can't use 
     * the `translate="no"` attr.
     * 
     * Froala does not let us select partial HTML.
     * We must select the entire el.
     **/
    const editorText = editor.selection.text();
    const editorHTML = editor.html.get();
    const textToTranslate = editorText || editorHTML;

    const shouldReplaceSelectedText = editorText !== '';

    const onTranslationSave = (translatedHtml) => {

      if (shouldReplaceSelectedText) {
        // https://wysiwyg-editor.froala.help/hc/en-us/articles/115000461089-Can-I-disable-wrapping-content-with-P-tags-
        editor.opts.enter = FroalaEditor.ENTER_BR;
        editor.html.insert(translatedHtml);
        editor.opts.enter = FroalaEditor.ENTER_P;
      } else {
        editor.html.set(translatedHtml);
      }

      editor.undo.saveStep();
    };

    if (textToTranslate) {
      store.dispatch(openTextTranslationModal(
        textToTranslate,
        onTranslationSave,
        {
          froalaConfig: {},
          shouldUseFroalaComponent: true
        }
      ));
    } else {
      store.dispatch(showNotificationWarning({
        message: 'There is no text to translate.'
      }));
    }
  }

  return {
    pluginTranslateText
  };
};


export const initializeTranslateTextPlugin = (store) => {
  FroalaEditor.PLUGINS[TRANSLATE_TEXT_PLUGIN] = (editor)=> translateTextPlugin(editor, store);

  FroalaEditor.DefineIcon(TRANSLATE_TEXT_PLUGIN_ICON, {
    NAME: 'language',
    FASNAME: 'language',
    SVG_KEY: 'trannslateText',
    template: 'font_awesome'
  });

  FroalaEditor.RegisterCommand(TRANSLATE_TEXT_PLUGIN, {
    title: 'Translate Text',
    icon: TRANSLATE_TEXT_PLUGIN_ICON,
    undo: false,
    focus: true,
    plugin: TRANSLATE_TEXT_PLUGIN,
    callback: function() {
      this[TRANSLATE_TEXT_PLUGIN].pluginTranslateText();
    }
  });
};
